import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import {
    CustomAccountSettingsFieldStateType,
    CustomAccountSettingsState,
} from "@solveindustrial/Store/State/AccountSettings/AccountSettingsState";
import { Draft } from "immer";

export const initialAccountSettingState: CustomAccountSettingsState = {
    hasChanges: false,
    restartForm: false,
    customFields: {},
};

export const customAccountSettingsReducer = createTypedReducer(initialAccountSettingState, {
    "Custom/AccountSettings/SetFields": (
        draft: Draft<CustomAccountSettingsState>,
        {
            customFields,
            hasChanges = false,
        }: { customFields: CustomAccountSettingsFieldStateType; hasChanges?: boolean },
    ) => ({ ...draft, customFields, hasChanges: draft.hasChanges != null && draft.hasChanges ? true : hasChanges }),

    "Custom/AccountSettings/ResetCustomFields": (
        draft: Draft<CustomAccountSettingsState>,
        { restartForm }: { restartForm: boolean },
    ) => ({ ...draft, restartForm }),
});
